<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">所有功能一覽</h1>
                        <h2>Trinka 的核心特色</h2>
                        <p>Trinka 是全球首款專為學術與技術寫作量身打造的語法與語言優化工具。<br/>它不只檢查文法和拼字錯誤，更進一步協助作者全方位提升語言表達能力。</p>
                    </div>
                    <div class="top-banner-right">
                        <img src="assets/images/features/FeaturesTopBanner.webp" width="388" height="360" alt="features" class="md50 w-auto" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0 card-carousel">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="trinka-title mb-50 text-center">
                    <h2>強大的文法與拼字檢查</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>學術寫作需具備清晰、簡潔、正式、客觀與易讀的特性。Trinka 提供全方位的語言優化，讓你能更有自信地溝通表達。</p>
                </div>
            </div>
            <div class="col-md-12 col-lg-12">
                <div id="spell-check-carousel" class="carousel slide" data-ride="carousel">
                    <!-- Indicators/dots -->
                    <div class="carousel-indicators">
                        <button type="button" data-target="#spell-check-carousel" data-slide-to="0" class="active">
                            <span></span> 高級文法檢查
                        </button>
                        <button type="button" data-target="#spell-check-carousel" data-slide-to="1">
                            <span></span> 句構調整
                        </button>
                        <button type="button" data-target="#spell-check-carousel" data-slide-to="2">
                            <span></span> 字詞選擇
                        </button>
                        <button type="button" data-target="#spell-check-carousel" data-slide-to="3">
                            <span></span> 用法與風格
                        </button>
                        <button type="button" data-target="#spell-check-carousel" data-slide-to="4">
                            <span></span> 英式／美式英文切換
                        </button>
                        <button type="button" data-target="#spell-check-carousel" data-slide-to="5">
                            <span></span> 高級拼字檢查
                        </button>
                    </div>
                    <!-- The slideshow/carousel -->
                    <div class="ct-card">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="carousel-card text-center">
                                    <h4>高級文法檢查</h4>
                                    <p>Trinka 能修正超過 3,000 種其他工具無法偵測的複雜文法錯誤，讓你的文章更清晰、條理分明。</p>
                                    <div class="sentence-card text-center">
                                        <p>Neither the healthy individuals nor the patient
                                            <span class="wrongText">recognize</span>
                                            <span class="rightText">recognizes</span> the visual discrepancies.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>句構調整</h4>
                                    <p>Trinka 根據主詞自動調整句子結構，使內容更易理解。</p>
                                    <div class="sentence-card text-center">
                                        <p>The students don't enjoy
                                            <span class="wrongText">to go</span>
                                            <span class="rightText">going</span> over the same rules again and again.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>字詞選擇</h4>
                                    <p>Trinka 修正錯誤用詞，讓你的表達更準確明確。</p>
                                    <div class="sentence-card text-center">
                                        <p>One of the reasons is
                                            <span class="wrongText">because</span>
                                            <span class="rightText">that</span> the fabrication cost
                                            <span class="wrongText">for</span>
                                            <span class="rightText">of</span> steel members depends upon the material.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>用法與風格</h4>
                                    <p>Trinka 優化措辭，讓寫作更具專業與正式風格，展現自信。</p>
                                    <div class="sentence-card text-center">
                                        <p>However, his method is novel and is
                                            <span class="wrongText">very much</span>
                                            <span class="rightText">considerably</span> different from the classical method.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>英式／美式英文切換</h4>
                                    <p>選擇英式或美式英文風格，讓 Trinka 協助你依照讀者或期刊要求進行調整。</p>
                                    <div class="sentence-card text-center">
                                        <p>The upper limbs of the patient were
                                            <span class="wrongText">paralysed</span>
                                            <span class="rightText">paralyzed.</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>高級拼字檢查</h4>
                                    <p>Trinka 結合語境判斷，協助你選用正確字詞，避免拼寫尷尬錯誤。</p>
                                    <div class="sentence-card text-center">
                                        <p>The
                                            <span class="wrongText">Bonferoni</span>
                                            <span class="rightText">Bonferroni</span> test was used to check for statistical significance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Left and right controls/icons -->
                        <button class="carousel-control-prev" type="button" data-target="#spell-check-carousel" data-slide="prev" aria-label="Previous Slide">
                            <span class="carousel-control-prev-icon"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-target="#spell-check-carousel" data-slide="next" aria-label="Next Slide">
                            <span class="carousel-control-next-icon"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0 card-carousel publishEnhancements">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="trinka-title mb-50 text-center">
                    <h2>投稿發表強化功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 協助你調整語氣、表達方式與用字，讓文章符合學術寫作的慣例與最佳實務，讓你能專注在內容與論點本身。</p>
                </div>
            </div>
            <div class="col-md-12 col-lg-12">
                <div id="publishEnhancements" class="carousel slide" data-ride="carousel">
                    <!-- Indicators/dots -->
                    <div class="carousel-indicators">
                        <button type="button" data-target="#publishEnhancements" data-slide-to="0" class="active">
                                <span></span> 風格指南建議
                        </button>
                        <button type="button" data-target="#publishEnhancements" data-slide-to="1">
                                <span></span> 字數縮減
                        </button>
                        <button type="button" data-target="#publishEnhancements" data-slide-to="2">
                                <span></span> 去除偏見用語
                        </button>
                        <button type="button" data-target="#publishEnhancements" data-slide-to="3">
                                <span></span> 避免模糊表達
                        </button>
                        <button type="button" data-target="#publishEnhancements" data-slide-to="4">
                                <span></span> 技術用語建議
                        </button>
                        <button type="button" data-target="#publishEnhancements" data-slide-to="5">
                                <span></span> 學術語氣調整
                        </button>
                    </div>
                    <!-- The slideshow/carousel -->
                    <div class="ct-card">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="carousel-card text-center">
                                    <h4>風格指南偏好設定</h4>
                                    <p>Trinka 根據 AMA、APA 等寫作規範提出用詞建議，幫助你準備投稿。</p>
                                    <div class="sentence-card text-center">
                                        <p>The man
                                            <span class="wrongText">suffered from</span>
                                            <span class="rightText">had</span> chronic kidney disease.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>字數縮減</h4>
                                    <p>Trinka 自動刪除冗詞贅句，協助你達成期刊字數限制。</p>
                                    <div class="sentence-card text-center">
                                        <p>Bcl6 deficiency in T cells resulted in
                                            <span class="wrongText">the reduction of
                                            </span>
                                            <span class="rightText">reduced</span> mRNA expression.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>去除偏見用語</h4>
                                    <p>Trinka 會修正具有偏見或不當的用詞，讓你的表達更具包容性與專業性。</p>
                                    <div class="sentence-card text-center">
                                        <p>The
                                            <span class="wrongText">retarded children</span>
                                            <span class="rightText">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>避免模糊表達</h4>
                                    <p>Trinka 協助你讓寫作更明確、直接，提升溝通效果變得輕而易舉。</p>
                                    <div class="sentence-card text-center">
                                        <p>
                                            <span class="wrongText">Some studies</span>
                                            <span class="rightText">Studies</span> have shown that children not participating in co-curricular activities
                                            may not develop the necessary social skills in adulthood.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>技術用語建議</h4>
                                    <p>Trinka 會依據你的主題領域建議合適用詞，幫助你選出更精準的表達，讓內容更貼近讀者。</p>
                                    <div class="sentence-card text-center">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span class="wrongText">transverse myelitis with long spinal cord lesions
                                            </span>
                                            <span class="rightText">longitudinally extensive transverse myelitis.</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <div class="carousel-card text-center">
                                    <h4>學術語氣調整</h4>
                                    <p>Trinka 讓你的寫作更具正式語氣，提升整體專業度，讓讀者印象深刻，專業寫作變得簡單又有效！</p>
                                    <div class="sentence-card text-center">
                                        <p>Children actively engage in activities
                                            <span class="wrongText">like</span>
                                            <span class="rightText">such as</span> outdoor games, skits, and other team activities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Left and right controls/icons -->
                        <button class="carousel-control-prev" type="button" data-target="#publishEnhancements" data-slide="prev" aria-label="Previous Slide">
                            <span class="carousel-control-prev-icon"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-target="#publishEnhancements" data-slide="next" aria-label="Next Slide">
                            <span class="carousel-control-next-icon"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="list-wrapper-style-2 section-pd pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center ">
                    <h2>作家工具組 </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="section-pd list-wrapper-style-2 pt-40">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3 class="d-flex align-items-center">AI Studio  <div class="beta-badge">全新推出</div></h3>
                            <p>運用專為各類寫作任務設計的 AI 應用程式，快速且大規模產出高品質內容。</p>
                            <a [routerLink]="['/features/ai-studio/ai-writing-tools']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img pr-0">
                            <img src="assets/images/features/ai-studio/ai-app-library-banner.png" width="1506" height="980" class="img-fluid" alt="proofread" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="row no-margin align-items-center flex-row-reverse">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>抄襲檢查</h3>
                        <p>體驗業界最精準的文字相似度演算法，搭配涵蓋各學科的最大型付費出版資料庫，提供高品質抄襲檢測服務。</p>
                        <a [routerLink]="['/features/plagiarism-check']" class="link-text">
                            了解更多
                            <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-image">
                        <img src="assets/images/features/pc-check.webp" width="426" height="311" class="img-fluid" alt="Plagiarism Check" />
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>自動文件編輯</h3>
                            <p>一次完成全面語言修訂，所有變更皆標示可供審閱。只需上傳 Word 文件，Trinka 即可自動編修並提供含修訂記錄的檔案。</p>
                            <a [routerLink]="['/features/proofread-file']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/proofread.svg" width="406" height="297" class="img-fluid" alt="proofread" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="section-pd list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>Publication Readiness Checks</h3>
                            <p>Ready to submit your paper? Trinka evaluates your manuscript against 20+ checkpoints that match journal editorial checks so you can confidently submit it to your desired journal.</p>
                            <a [routerLink]="['/features/publication-readiness-checks']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/s3.svg" width="406" height="275" class="img-fluid" alt="publication">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>線上改寫工具</h3>
                            <p>AI 驅動的改寫功能能理解你的寫作意圖，並提出清晰、通順且語法正確的改寫建議。</p>
                            <a [routerLink]="['/features/paraphraser']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/paraphraser.webp" width="426" height="331" class="img-fluid" alt="publication">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>引文檢查器</h3>
                            <p>引文檢查功能能辨識可能削弱論點的引用來源，並協助你選擇更具可信度的資料支持研究主張。</p>
                            <a [routerLink]="['/features/citation-checker']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/s2.svg" width="406" height="275" class="img-fluid" alt="citation">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>引文格式整理器</h3>
                            <p>一次完成所有主流格式的引文整理、格式標準化與驗證，提升效率與稿件品質。</p>
                            <a [routerLink]="['/features/citation-formatter']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/Citation_Formatter_feature.svg" width="515" height="350" class="img-fluid" alt="publication">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>期刊查找</h3>
                            <p>透過比對你論文的主題與概念，結合數百萬篇發表文獻及出版趨勢，幫助你找到最合適的投稿期刊。</p>
                            <a  [routerLink]="['/features/journal-finder']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/s1.svg" width="406" height="275" class="img-fluid" alt="journal-finder">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>一致性檢查</h3>
                            <p>寫作風格一致性強化溝通力。Trinka 的一致性檢查可一鍵修正如連字號、拼字與大小寫等前後不一致問題。</p>
                            <a [routerLink]="['/features/consistency-check']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/Consistency-Check.svg" width="426" height="311" class="img-fluid" alt="consistency" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>個人詞庫</h3>
                            <p>打造專屬寫作體驗！你可以新增無限制的自訂字彙，Trinka 會記住並應用於後續檢查中。</p>
                            <a [routerLink]="['/features/personal-dictionary']" class="link-text">
                                了解更多
                                <img src="assets/images/ReadMoreArrow-blue.png" width="14" height="13" alt="icon">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/Personal-Dictionary.webp" width="426" height="311" class="img-fluid" alt="personal-dictionary" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-pd pt-0">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>下載含修訂記錄的文件</h3>
                            <p>想檢視所有修改？非常簡單，只要下載含「修訂記錄」的 Word 文件，即可隨時在 MS Word 中查看所有變更。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/DownloadFileTrackChanges.svg" width="426" height="311" class="img-fluid" alt="document changes" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">還在等什麼？</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" class="white-btn" target="_blank">立即免費註冊</a>
                    <a [routerLink]="['/grammar-checker']" class="white-btn">立即線上體驗</a>
                </div>
            </div>
        </div>  
    </div>
</section>